import { LOGIN_TYPE } from './../configs/constant/common';
import { TopicItem } from 'configs/constant/corpus';
import ppo from 'ppo';

// 从一个数组中获取指定value的key
export const getNameFromArr = (arr: any, value: string | number, key = 'label', valueKey = 'value') => {
  const res = arr ? arr.find((item: any) => item[valueKey] === value) : null;
  return res?.[key] !== undefined ? res?.[key] : '';
};

export const isNul = (tmp: number | string | null | undefined) => typeof tmp === 'undefined' || tmp === null || tmp.toString().trim() === '';

/* 是否正式环境 */
export const IS_PROD = process.env.NODE_ENV?.toLowerCase() === 'production';

/**
 * （保留n位小数,得到字符串）
 */
export const formatFloat = (value: number, n = 2, down?: boolean) => {
  let result = '0';
  try {
    if (!value) {
      return result;
    }
    if (down) {
      // 向下保留n位小数
      // eslint-disable-next-line no-restricted-properties
      result = String(Math.floor(value * Math.pow(10, n)) / Math.pow(10, n));
    } else {
      // 四舍五入保留n位小数
      // eslint-disable-next-line no-restricted-properties
      result = ((value * Math.pow(10, n)) / Math.pow(10, n)).toFixed(n);
    }
    return result;
  } catch (error) {
    return result;
  }
};

export const generateRandomString = (length: number) => {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const getColoumnFilter = (coloumnMap: { [x: string]: { options: any } }, key: string) => {
  const optionsMap = coloumnMap[key].options;
  const optionsFilterArr: { value: string; text: any }[] = [];
  Object.keys(optionsMap).forEach((key) => {
    optionsFilterArr.push({
      value: key,
      text: optionsMap[key],
    });
  });
  return optionsFilterArr;
};

export const filterOption = (input: string, option?: { label: string; value: string }) =>
  (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

export const pickElementsWithRatio = (arr: TopicItem[], ratio = 0) => {
  const numberOfElementsToPick = Math.round(arr.length * ratio * 0.01);
  const indexArr = Array.from({ length: arr.length }, (_, i) => i);
  const pickIndexArr = [];
  const pickedElements: TopicItem[] = [];
  const shuffledArray = indexArr.sort(() => Math.random() - 0.5); // 随机打乱数组顺序
  for (let i = 0; i < numberOfElementsToPick; i++) {
    pickIndexArr.push(shuffledArray[i]);
  }
  for (let i = 0; i < pickIndexArr.length; i++) {
    pickedElements.push(arr[i]);
  }
  return pickedElements?.length === 0 ? [arr[shuffledArray[0]]] : pickedElements;
};

const localUserRtx = 'jiangyinsu';

export const getUserKey = (user: string) => {
  // const isWxLogin = getIsWxLogin();
  // const isPswLogin = getIsPswLogin();
  const userId = ppo.getCookie('user-id');
  console.log('getUserKey user', user);
  return window.location.hostname === 'localhost' ? localUserRtx : userId;
  // isWxLogin ? localStorage.getItem('UG_CAIDATA_OPENID') : isPswLogin ? localStorage.getItem('UG_CAIDATA_PSW_USER_ID') : user;
};

// 外部登录
export const getIsExternalLogin = (accountType: string) => {
  const isWxLogin = getIsWxLogin(accountType);
  const isPswLogin = getIsPswLogin(accountType);
  return isWxLogin || isPswLogin;
};

export const getLoginAccountType = () => {
  return window.location.hostname === 'localhost' ? LOGIN_TYPE.rtx : localStorage.getItem('UG_CAIDATA_LOGIN_TYPE') || '';
};

export const getIsWxLogin = (accountType: string) => {
  return accountType === LOGIN_TYPE.wx;
  // return window.location.hostname === 'caidata.qq.com' || false;
};

export const getIsRtxLogin = (accountType: string) => {
  // 本地不能调成rtx登录
  return accountType === LOGIN_TYPE.rtx;
  // 如果这样，那么woa的域名展示不了登录页面
  // return window.location.hostname === 'caidata.woa.com' || window.location.hostname === 'testcaidata.woa.com' || false;
};
export const getIsPswLogin = (accountType: string) => {
  // return localStorage.getItem('UG_CAIDATA_LOGIN_TYPE') === LOGIN_TYPE.rtx;
  return accountType === LOGIN_TYPE.psw;
};
export const getIsExistLoginType = () => {
  // return localStorage.getItem('UG_CAIDATA_LOGIN_TYPE') === LOGIN_TYPE.rtx;
  return Object.values(LOGIN_TYPE).includes(getLoginAccountType());
};
export const defaultUserName = '***';

export const getWoaDomain = () => {
  return window.location.hostname;
};

export const getIsQqDomain = () => {
  return window.location.hostname.includes('qq.com');
};

export const getCaiQQDomain = () => {
  return IS_PROD ? 'ugactt.qq.com' : 'ugactt.qq.com';
};

export const getCaiWoaDomain = () => {
  return IS_PROD ? 'cai.woa.com' : 'testcai.woa.com';
};
